module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-support-view/master-support-view.component.scss
// module id = ./src/app/master/master-support-view/master-support-view.component.scss
// module chunks = main